document.addEventListener("DOMContentLoaded", function () {
    var tabBtns = document.querySelectorAll(".tabs__head .tabs__btn");
    var tabContents = document.querySelectorAll(".tabs__body .tabs__content");

    if (tabBtns.length > 0 && tabContents.length > 0) {
        tabBtns.forEach(function (tabBtn, index) {
            tabBtn.addEventListener("click", function () {
                var isActive = tabBtn.classList.contains("active");

                // Remove active class from all buttons and hide all contents
                tabBtns.forEach(btn => btn.classList.remove("active"));
                tabContents.forEach(content => (content.style.display = "none"));

                // Toggle clicked tab
                if (!isActive) {
                    tabBtn.classList.add("active");
                    tabContents[index].style.display = "block";
                }
            });
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll("[data-js-tabs-btn-mobile]");
    const tabContents = document.querySelectorAll(".tabs__content");

    // Show the first tab content by default
    if (tabContents.length > 0) {
        tabContents.forEach(content => content.style.display = "none");
        tabContents[0].style.display = "block";
    }

    tabButtons.forEach(btn => {
        btn.addEventListener("click", function () {
            // Remove active class from all parents
            const tabParents = document.querySelectorAll("[data-js-tabs-tab]");
            tabParents.forEach(parent => parent.classList.remove("active"));

            // Add active class to the clicked tab's parent
            const parentTab = btn.closest("[data-js-tabs-tab]");
            if (parentTab) {
                parentTab.classList.add("active");
            }

            // Hide all contents first
            tabContents.forEach(content => content.style.display = "none");

            // Find the next sibling .tabs__content and show it
            let nextTabContent = btn.nextElementSibling;
            if (nextTabContent && nextTabContent.classList.contains("tabs__content")) {
                nextTabContent.style.display = "block";
            }
        });
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//     var tabBtns = document.querySelectorAll(".tabs__head .tabs__btn");
//     var tabContents = document.querySelectorAll(".tabs__body .tabs__content");
//     var reviewsSection = document.querySelector("#shopify-section-template--15466110713938__1745578549631417a3");
//     var tabsBody = document.querySelector(".tabs__body");

//     // Only hide the reviews section by default
//     if (reviewsSection) reviewsSection.style.display = "none";

//     if (tabBtns.length > 0 && tabContents.length > 0) {
//         tabBtns.forEach(function (tabBtn, index) {
//             tabBtn.addEventListener("click", function () {
//                 var isActive = tabBtn.classList.contains("active");

//                 // Remove active from all buttons, hide all tab contents
//                 tabBtns.forEach(btn => btn.classList.remove("active"));
//                 tabContents.forEach(content => (content.style.display = "none"));

//                 // Show clicked tab's content
//                 if (!isActive) {
//                     tabBtn.classList.add("active");
//                     tabContents[index].style.display = "block";
//                 }

//                 // Show reviews section if 'reviews' tab is clicked
//                 if (tabBtn.dataset.tab === "reviews" && reviewsSection) {
//                     reviewsSection.style.display = "block";
//                 } else if (reviewsSection) {
//                     reviewsSection.style.display = "none";
//                 }
//             });
//         });
//     }
// });
